import { useState, useEffect } from "react";

/**
 * Debounce a value - updates only after delay ms of no changes.
 * Reduces API calls when used with search inputs.
 *
 * @param {*} value - The value to debounce
 * @param {number} delay - Delay in ms (default 400)
 * @returns {*} - The debounced value
 */
export function useDebounce(value, delay = 400) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
